import React from "react";

function Colors_Triadic() {
  return (
    <div>
      <h1>Colors_Triadic Component</h1>
      <p>This is the Colors Triadic tutorial page content.</p>
    </div>
  );
}

export default Colors_Triadic;
